// extracted by mini-css-extract-plugin
export default {"profiles":"Profiles_profiles__SYFt8"};